<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height>
      <v-flex lg8>
        <v-layout align-center justify-center>
          <success-view
            v-if="success"
            title="Contraseña temporal enviada"
            message="Se envió una notificación con una contraseña temporal a tu cuenta de Slack para recuperar tu usuario. Usa esta contraseña temporal para generar una nueva"
            redirect="/login"
          />
          <v-card v-else width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Olvido de contraseña
                  </v-flex>
                </v-layout>
                <template v-if="!success">
                  <v-divider></v-divider>
                  <v-divider ></v-divider>
                </template>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <span class="grey--text">
                      Ingresa tu correo electrónico y te enviaremos una contraseña temporal a tu cuenta de Slack
                      para recuperar tu usuario
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-form @submit.prevent @keyup.native.enter="getTemporalPassword()">
                      <v-text-field
                        v-model="form.email"
                        v-validate="'required|email'"
                        data-vv-scope="forgotPassword"
                        data-vv-name="email"
                        :error-messages="errors.collect('forgotPassword.email')"
                        label="Email"
                        color="black"
                        type="text">
                      </v-text-field>
                      <v-btn
                        class="k-orange-linear white--text"
                        :disabled="loading || errors.any('forgotPassword.email')"
                        block
                        large
                        @click="getTemporalPassword()"
                      >
                        ENVIAR
                      </v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')" width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Sidebar from '@/components/login/Sidebar';
import SuccessView from '@/components/global/SuccessView';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
    SuccessView,
  },
  beforeRouteEnter(to, from, next) {
    localStorage.clear();
    next();
  },
  mounted() {
    this.$validator.reset();
    this.errors.clear();
  },
  data() {
    return {
      loading: false,
      success: false,
      form: {
        email: '',
      },
    };
  },
  methods: {
    getTemporalPassword() {
      this.$validator.validateAll('forgotPassword')
        .then((validation) => {
          if (validation) {
            this.loading = true;
            this.errors.clear();
            this.axios.post('auth/get_temporal_password', this.form)
              .then(() => {
                this.success = true
              })
              .catch((error) => {
                let msg = (((error || {}).response || {}).data || {}).message;
                if (msg) {
                  this.errors.add({
                    field: 'forgotPassword.email',
                    msg,
                  });
                }
              })
              .finally(() => {
                this.loading = false
              });
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/ForgotPassword.vue